module.exports = __webpack_public_path__ + "static/media/filter.b9a6450f.svg";